export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-universal-access-f7a0b9b30a261f834df9f2a0369c4648.svg";